



































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Applications, { Application } from '@/services/Applications';
import { Provider } from '@/services/Providers';
import Quotes, { PolicyType, Quote } from '@/services/Quotes';

@Component({
     name: 'ApplicationPendingWidget',
})
export default class ApplicationPendingWidget extends Vue {
     private application: Application | null = null;
     private quote: Quote | null = null;

     private get hasApplicationPending(): boolean {
          return !!this.application && !!this.quote;
     }

     private get isClaimsMade(): boolean {
          return !!this.quote && this.quote.policyParams.policyType === PolicyType.claimsMade;
     }

     private async created(): Promise<void> {
          // Get all unexpired applications for the current user.
          const applications: Application[] = await Applications.readApplicationsForUserId();
          if (applications.length === 0) {
               return;
          }

          // Find the newest application for which there are incomplete provider profiles.
          const application: Application | undefined = applications.find(
               (candidate: Application): boolean =>
                    candidate.providers.some((provider: Provider): boolean => !provider.profile),
          );
          if (!application) {
               return;
          }

          // Get the quote associated with the application.
          const quote: Quote | undefined = await Quotes.readQuote(application.quoteId);
          if (!quote) {
               return;
          }

          // Update data.
          this.application = application;
          this.quote = quote;
     }
}
